import React, { Component } from 'react'
import { TableComp } from 'sz-react-utils-lite'
import { connect } from 'react-redux'
import {
  DefaultTablePagination, displayDate
} from '../../components/_utils/appUtils'
import { ColumnWidth } from '../WebComponent/columnWidth'
import { getCyprusFamTourListFxn } from './actions'
import { Col, DatePicker, Row } from 'antd'
import InputBox from '../../components/_utils/InputBox'
import AgentTypeheadComponent from '../../components/_utils/AgentTypeheadComponent'
import moment from 'moment'

const { RangePicker } = DatePicker

class AgentCyprusFamTourList extends Component {
  componentDidMount() {

  }

  constructor(props) {
    super(props)
    this.state = {
      agentId: '',
      total: 0,
      fromDate: '',
      toDate: ''

    }
    this.tableRef = React.createRef()
  }

  events = {
    reload: () => {
      this.tableRef.current.reload()
    }
  }

  apiRequest = (params) => {
    const { dispatch } = this.props
    if (this.state.agentId) {
      params.agentId = this.state.agentId
    }
    if (this.state.fromDate && this.state.toDate) {
      params.createdAt = {
        $gte: moment(this.state.fromDate).startOf('day').toDate(),
        $lte: moment(this.state.toDate).endOf('day').toDate()
      }
    }
    return new Promise(async (resolve) => {
      const { data } = await dispatch(getCyprusFamTourListFxn(params))
      console.log(data, 'data')
      this.setState({ total: data.data.total })
      resolve(data.data)

    })
  }

  searchFxn = async () => {
    this.events.reload()
  }

  clearFxn = async () => {
    this.setState({
      agentId: '',
      toDate: '',
      fromDate: ''
    })
    setTimeout(() => {
      this.events.reload()
    }, 200)
  }

  render() {
    const columns = [
      {
        title: '#',
        key: '_id',
        dataIndex: '_id',
        width: 50,
        render: (ite, record, index) => index + 1
      },
      {
        title: 'Agent',
        key: 'name',
        dataIndex: 'name',
        width: 250,
        render: (item, record) => (
          <ColumnWidth width={250}>
            {item}
          </ColumnWidth>
        )
      },
      {
        title: 'Company Name',
        key: 'agentId',
        dataIndex: 'agentId',
        width: 250,
        render: (item, record) => (
          <ColumnWidth width={250}>
            {item && item.companyName && item.companyName}
          </ColumnWidth>
        )
      },
      {
        title: 'Email',
        key: 'email',
        dataIndex: 'email',
        width: 200,
        render: (item, record) => (
          <ColumnWidth width={250}>
            {item}
          </ColumnWidth>
        )
      },
      {
        title: 'Mobile',
        key: 'agentId',
        dataIndex: 'agentId',
        width: 150,
        render: (item, record) => (
          <ColumnWidth width={150}>
            {item && item.countryCode && item.countryCode} {item && item.mobile && item.mobile}
          </ColumnWidth>
        )
      },
      {
        title: 'Address',
        key: 'agentId',
        dataIndex: 'agentId',
        width: 250,
        render: (item, record) => (
          <ColumnWidth width={250}>
            {item && item.cityName && item.cityName}, {item && item.stateName && item.stateName}, {item && item.countryName && item.countryName}
          </ColumnWidth>
        )
      },
      {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        width: 100,
        render: (item) => (
          <ColumnWidth width={100}>
            <div className={''}>
              {item}
            </div>
          </ColumnWidth>
        )
      },
      {
        title: 'Added On',
        key: 'createdAt',
        dataIndex: 'createdAt',
        width: 100,
        render: (item) => (
          <ColumnWidth width={250}>
            <strong>{item && displayDate(item)}</strong>
          </ColumnWidth>
        )
      }
    ]
    return (
      <div className='row mt-4'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='table-head d-flex align-items-center'>
              <h5>Cyprus Fam Tour List ({this.state.total})</h5>
              <div className='search-box-table'>

              </div>
            </div>
            <div className='card-body table-responsive'>
              <Row gutter={12} className={'filter_box'}>
                <Col span={6}>
                  <InputBox title={'Search by agent'}>
                    <AgentTypeheadComponent
                      key={this.state.agentId}
                      agentId={this.state.agentId}
                      dispatch={this.props.dispatch}
                      customStyle={''}
                      onSelect={item => {
                        this.setState({ agentId: item })
                      }}
                    />
                  </InputBox>
                </Col>
                <Col md={6} sm={6} xs={6} lg={6} key={this.state.fromDate}>
                  <InputBox title={'Search by added date'}>
                    <RangePicker
                      defaultValue={[this.state.fromDate, this.state.toDate]}
                      onChange={val => {
                        this.setState({ fromDate: val[0] })
                        this.setState({ toDate: val[1] })
                      }}
                    />
                  </InputBox>
                </Col>
                <Col span={24}>
                  <div className={'btn_group'}>
                    <a className={'default_btn'} onClick={() => this.searchFxn()}>Search</a>
                    <a className={'default_btn'} onClick={() => this.clearFxn()}>Clear</a>
                  </div>
                </Col>
              </Row>
              <TableComp
                columns={columns}
                ref={this.tableRef}
                pagination={DefaultTablePagination()}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 1000 } }}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ global }) => ({
  categories: global.categories,
  currentUser: global.currentUser
})

export default connect(mapStateToProps)(AgentCyprusFamTourList)
